<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson mb2 pb4">
      <!-- back button -->
      <template>
        <div class="px2 py1 ml4 mb2" v-if="!showMobile">
          <!-- back button -->
          <a href="javascript:history.go(-1)" class="h5 primarycolor no-hover block no-hover gibson line-height-1 semi-bold">
            <span class="mr2"><i class="el-icon-back"></i></span>
            <span>Tilbage</span>
          </a>
        </div>
        <div class="px2 py1 mb2" v-else>
          <!-- back button -->
           <a href="javascript:history.go(-1)" class="h5 primarycolor no-hover block no-hover gibson line-height-1 semi-bold">
            <span class="mr2"><i class="el-icon-back"></i></span>
            <span>Tilbage</span>
          </a>
        </div>
      </template>
      <!-- small and large desktop setup -->
      <div class="px2 mx4" v-if="!showMobile">
        <!-- reference table -->
        <div class="clearfix border muted-border p2 pb4 mb2 shadow">
          <!-- all tilbud header -->
          <div class="my3 px2">
            <p class="h4 semi-bold darkblue line-height-4 gibson">
              Alle tilbud
            </p>
          </div>
          <!-- small and large desktop table -->
          <div>
            <div class="table-responsive" striped bordered>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <span class="h6 semi-bold line-height-1 m0 gibson gibson">Adresse</span>
                    </th>
                    <th>
                      <span class="h6 semi-bold line-height-1 m0 gibson gibson">Date sent</span>
                    </th>
                    <th>
                      <span class="h6 semi-bold line-height-1 m0 gibson gibson">Status</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="quotation in quotations" :key="quotation.id">
                    <td>
                      <span class="semi-bold line-height-1 m0 gibson" style="font-size:85%" v-if="quotation.info.reference_number">{{quotation.info.reference_number}}</span>
                    </td>
                    <td>
                      <span class="regular line-height-1 m0 gibson" style="font-size:85%" v-if="quotation.name">{{quotation.name}}</span>
                    </td>
                    <td>
                      <span class="regular line-height-1 m0 gibson" style="font-size:85%" v-if="quotation.info.date">{{quotation.info.date || moment}}</span>
                    </td>
                    <td>
                      <span class="regular line-height-1 m0 gibson" style="font-size:85%" v-if="quotation.info.expiry_date">{{quotation.info.expiry_date || moment}}</span>
                    </td>
                    <td>
                      <span class="regular line-height-1 m0 gibson" style="font-size:85%" v-if="quotation.sent">{{quotation.sent}}</span>
                    </td>
                    <td>
                      <span class="h6 regular line-height-1 m0 gibson">
                        <span class="yellow-background darkblue regular p1 inline-block" v-if="quotation.is_draft === '1'">Draft</span>
                        <span class="more-muted-background darkblue regular p1 inline-block" v-if="quotation.condition === '1'">
                          <span>
                            <i class="el-icon-time"></i>
                          </span>
                          <span class="regular mb0 mr2" style="font-size:75%">
                            Afventer
                          </span>
                        </span>
                      </span>
                    </td>
                    <td class="table-option text-center">
                      <div class="btn-group">
                        <button class="dark-button line-height-1 p1 flex justify-start items-center gibson border-none mr1" @click="showItemDetails(quotation)">
                          <span class="regular mb0 mr2" style="font-size:75%">
                            View
                          </span>
                          <span>
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                        <button class="action-button line-height-1 p1 flex justify-start items-center gibson border-none mr1">
                          <span class="regular mb0 mr2" style="font-size:75%">
                            Send
                          </span>
                          <span>
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                        <button class="warning-button line-height-1 p1 flex justify-start items-center gibson mr1" tooltip="Edit" @click.prevent="editQuotation(quotation)">
                          <span class="regular mb0 mr2" style="font-size:75%">
                            Edit
                          </span>
                          <span>
                            <i class="el-icon-edit"></i>
                          </span>
                        </button>
                        <button class="delete-action-button line-height-1 border-none flex justify-start items-center gibson px2 py1" :key="quotation.id" v-confirm="{ok: confirmDelete(quotation)}" tooltip="Slet">
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- single tilbud -->
        <div class="clearfix border muted-border p2 px3 pb3 mt4 mb2 shadow">
          <div>
            <!-- title - header - text -->
            <p class="h6 gibson regular line-height-2 mt2 mb1">Tilbud</p>
            <p class="h4 semi-bold darkblue gibson line-height-golden mb1">{{customer.firstname}} {{customer.lastname}}</p>
            <ol class="breadcrumb list-reset border-none mb0">
              <li class="breadcrumb-item h5 gibson">
                <router-link to="/alle-moeder">Alle møder</router-link>
              </li>
              <li class="breadcrumb-item h5 gibson active">Tilbud</li>
            </ol>
            <p class="h5 darkblue regular line-height-golden mb2 col-7 px0">
              Her har vi samlet informationerne omkring dit partnerskab. Portalen giver dig blandt andet følgende muligheder:
            </p>
            <!-- customer information -->
            <div class="col-6 px0">
              <button v-b-toggle.collapse2 class="col-12 px0 white-button p1 flex justify-between items-center gibson">
                <p class="h5 semi-bold line-height-1 mb0">
                  Kundeinfo
                </p>
                <span class="when-closed">
                  <span class="relative" style="top:3px;">
                    <svg fil="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>                    </span>
                  </span>
                <span class="flex-none when-opened">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- customer information collapse -->
            <b-collapse id="collapse2" class="mt2">
              <div class="clearfix">
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Navn :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{customer.firstname}} {{customer.lastname}}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Email :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{customer.email}}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Mobile :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{customer.mobile}}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Adresse :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{ customer.mailingstreet }} {{ customer.mailingzip }} {{ customer.mailingcity }}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Mødedato :</p>
                  <p class="h5 semi-bold darkblue line-height-3 gibson" v-if="app.hentilbud === 0">{{moment(app.appointment_date).locale('da').format('LL')}}<br>kl. {{app.id_times}} </p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Prisen er inkl. moms :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson" v-if="app.hentilbud === 0">{{customer.lowamountmoms}} - {{customer.highamountmoms}} kr.</p>
                </div>
                <div class="col-7 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Kommentarer</p>
                  <p class="h5 regular darkblue line-height-4 gibson" v-if="app.hentilbud === 0">{{app.comment_to_partner}}</p>
                </div>
                <div class="col-12 px1" v-if="customer.files.length !== 0">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Filer</p>
                  <ul style="list-style: none;padding: 0;" class="m-t-10">
                    <li v-for="attachment in customer.files" :key="attachment.id" class="py-1">
                      <a :href="attachment" ><i class="el-icon-paperclip"></i> {{attachment.substring(attachment.lastIndexOf('/')+1)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </b-collapse>
            <!-- opgavens indhold -->
            <div class="col-6 px0 flex justify-between items-center">
              <button v-b-toggle.collapse3 class="col-12 px0 white-button p1 flex justify-between items-center gibson">
                <p class="h5 semi-bold line-height-1 mb0">
                  Opgavens indhold
                </p>
                <span class="when-closed">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>                    </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- opgavens indhold collapse -->
            <b-collapse id="collapse3" class="mt2">
              <div class="clearfix">
                <div class="col-6 px0">
                  <b-table striped hover :items="items" class="mb4"></b-table>
                </div>
              </div>
            </b-collapse>
            <!-- pictures -->
            <div class="col-6 px0 flex justify-between items-center">
              <button v-b-toggle.collapse4 class="col-12 px0 white-button p1 flex justify-between items-center gibson">
                <p class="h5 semi-bold line-height-1 mb0">
                  Billeder
                </p>
                <span class="when-closed">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>                    </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- pictures collapse -->
            <b-collapse id="collapse4" class="mt2">
              <div class="flex flex-wrap justify-start items-center">
                <div class="col col-4" style="height:200px;" v-for="(image, i) in images" @click="onClick(i)" :key="image.id">
                  <img class="fit" :src="image">
                  <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
                </div>
              </div>
            </b-collapse>
            <!-- kom i hang button -->
            <div class="px0 my2">
              <button class="not-rounded action-button gibson p2 h4 flex justify-center items-center line-height-1" ref="addt" v-b-toggle.moretilbud name="moretilbud">
                <span class="regular gibson">Kom i gang</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <!-- offer creator -->
            <div class="col-9 mx-auto px0">
              <b-collapse id="moretilbud">
                <div class="clearfix my3">
                  <form @submit="onSubmitTilbud" @reset="resetForm">
                    <div class="clearfix">
                      <!-- main form for creator -->
                      <div class="col-12 px0">
                        <!-- offer creator logo upload -->
                        <div class="clearfix my2">
                          <!-- logo label -->
                          <p class="h6 regular darkblue gibson line-height-1">Logo</p>
                          <div v-if="!image" class="my2">
                            <input type="file" @change="onFileChange" class="col-12 muted-background darkblue gibson h5 p2">
                          </div>
                          <div v-else class="my2">
                            <div class="flex justify-between items-start">
                              <img width="80" :src="image" class="mb2 fit" />
                              <button class="not-rounded delete-button p1 border-none" @click="removeImage">
                                <span>
                                  <i class="el-icon-delete"></i>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix mb2">
                          <file-upload-input :token="quotationForm.upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
                        </div>
                        <!-- reference number -->
                        <div class="clearfix mb2">
                          <!-- reference label -->
                          <p class="h6 regular darkblue gibson line-height-1">Reference #</p>
                          <input class="col-12 muted-background darkblue h5 p2 border-none not-rounded" type="text" value="" v-model="quotationForm.reference_number" name="reference_number" required placeholder="Reference #">
                        </div>
                        <!-- date -->
                        <div class="clearfix mb2">
                          <!-- date label -->
                          <p class="h6 regular darkblue gibson line-height-1">Dato</p>
                          <datepicker v-model="quotationForm.date" :bootstrapStyling="false" placeholder="Dato" :language="da" class="muted-background p2 darkblue gibson h5 border-none not-rounded"></datepicker>
                        </div>
                        <!-- expiry date -->
                        <div class="clearfix mb2">
                          <!-- expiry label -->
                          <p class="h6 regular darkblue gibson line-height-1">Udløbsdato</p>
                          <datepicker v-model="quotationForm.expiry_date" :bootstrapStyling="false" placeholder="Udløbsdato" :language="da" class="muted-background p2 darkblue gibson h5 border-none not-rounded"></datepicker>
                        </div>
                        <!-- subject -->
                        <div class="clearfix mb2">
                          <!-- subject label -->
                          <p class="h6 regular darkblue gibson line-height-1">Subject</p>
                          <autosize-textarea v-model="quotationForm.subject" rows="1" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="subject" required placeholder="Subject"></autosize-textarea>
                        </div>
                        <!-- description -->
                        <div class="clearfix mb2">
                          <!-- description label -->
                          <p class="h6 regular darkblue gibson line-height-1">Desciption</p>
                          <autosize-textarea v-model="quotationForm.description" rows="5" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="description" placeholder="Desciption"></autosize-textarea>
                        </div>
                        <!-- default tac -->
                        <div class="clearfix mb2">
                          <!-- default tac label -->
                          <p class="h6 regular darkblue gibson line-height-1">Standard: Terms and conditions</p>
                          <autosize-textarea v-model="quotationForm.tnc" rows="3" name="tnc" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" placeholder="Display default obligatory terms and conditions here. Scrollable but not editable."></autosize-textarea>
                        </div>
                        <!-- custom tac -->
                        <div class="clearfix mt1 mb2">
                          <!-- custom tac label -->
                          <p class="h6 regular darkblue gibson line-height-1">Unikke: Terms and conditions</p>
                          <autosize-textarea v-model="quotationForm.tnc" rows="3" name="tnc" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" placeholder="Editable terms and conditions. Button should save text to send to customer "></autosize-textarea>
                          <button class="action-button p2 border-none line-height-1 not-rounded flex justify-center tems-center gibson mt1">
                            <span class="regular h4">Save edited text</span>
                            <span class="ml2">
                              <i class="el-icon-right"></i>
                            </span>
                          </button>
                        </div>
                        <!-- customer notes -->
                        <div class="clearfix mb2">
                          <!-- customer notes label -->
                          <p class="h6 regular darkblue gibson line-height-1">Customer note</p>
                          <autosize-textarea v-model="quotationForm.customer_note" rows="3" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="customer_note" placeholder="Customer Note"></autosize-textarea>
                        </div>
                        <!-- memo  -->
                        <div class="clearfix mb2">
                          <!-- memo label -->
                          <p class="h6 regular darkblue gibson line-height-1">Memo</p>
                          <autosize-textarea v-model="quotationForm.memo" rows="3" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="memo" placeholder="Memo"></autosize-textarea>
                        </div>
                        <!-- <div class="clearfix my3">
                          <b-form-checkbox id="checkbox1" v-model="quotationForm.is_draft" value=1 unchecked-value=0 checked-value=1>
                            <p class="h5 regular darkblue gibson line-height-1 mb0">Save as draft</p>
                          </b-form-checkbox>
                          <div class="py2"></div>
                          <div class="flex justify-between items-center mb3">
                            <button type="button" class="outlined-primary-button p2 not-rounded gibson h5" href="#/alle-moeder">
                              <span class="regular">Cancel</span>
                            </button>
                            <button type="submit" class="action-button p2 gibson border-none not-rounded h5">
                              <span class="regular">Send</span>
                            </button>
                          </div>
                        </div> -->
                      </div>
                      <!-- add row table -->
                      <div class="table-responsive clearfix col-12 px0">
                        <table class="table mb3">
                          <thead>
                            <tr>
                              <td class="plusminuscell">
                                <!-- add row button -->
                                <button class="action-button p1 regular flex justify-start items-center h6 line-height-1" @click="addRow" type="button">
                                  <span class="">
                                    <i class="el-icon-circle-plus-outline"></i>
                                  </span>
                                </button>
                              </td>
                              <td class="itemcell">
                                <!-- item button -->
                                <p class="white-button py1 regular flex justify-start items-center h6 line-height-1">
                                  <span style="margin-right:5px;">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="0" height="16" preserveAspectRatio="xMinYMin" class="jam jam-plus-rectangle"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z'/></svg>
                                  </span>
                                  <span>Item</span>
                                </p>
                              </td>
                              <td class="typecell">
                                <!-- type button -->
                                <p class="white-button py1 regular flex justify-start items-center h6 line-height-1">
                                  <span style="margin-right:5px;">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="0" height="16" preserveAspectRatio="xMinYMin" class="jam jam-plus-rectangle"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z'/></svg>
                                  </span>
                                  <span>Type</span>
                                </p>
                              </td>
                              <td class="quantitycell">
                                <!-- quantity button -->
                                <p class="white-button py1 regular flex justify-start items-center h6 line-height-1">
                                  <span style="margin-right:5px;">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="0" height="16" preserveAspectRatio="xMinYMin" class="jam jam-plus-rectangle"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z'/></svg>
                                  </span>
                                  <span>Quantity</span>
                                </p>
                              </td>
                              <td class="pricecell">
                                <!-- price button -->
                                <p class="white-button py1 regular flex justify-start items-center h6 line-height-1">
                                  <span style="margin-right:5px;">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="0" height="16" preserveAspectRatio="xMinYMin" class="jam jam-plus-rectangle"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z'/></svg>
                                  </span>
                                  <span>Pris</span>
                                </p>
                              </td>
                              <td class="amountcell darkblue-border">
                                <!-- amount button -->
                                <p class="white-button py1 regular flex justify-start items-center h6 line-height-1">
                                  <span style="margin-right:5px;">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="0" height="16" preserveAspectRatio="xMinYMin" class="jam jam-plus-rectangle"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z'/></svg>
                                  </span>
                                  <span>Amount</span>
                                </p>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row,index) in quotationForm.rows" :key="row.id">
                              <!-- delete row button -->
                              <td class="plusminuscell">
                                <button class="delete-button p1 regular flex justify-start items-center h6 line-height-1" type="button" :key="row.uuid" v-confirm="{ok: confirmRowDelete(row)}" tooltip="Slet">
                                  <i class="el-icon-delete"></i>
                                </button>
                              </td>
                              <!-- extra row item -->
                              <td class="itemcell">
                                <input type="text" class="muted-background darkblue p2 border-none not-rounded h6 mb2 col-12" :name="'item_name_'+index" v-model="row.custom_name" required placeholder="Title">
                                <autosize-textarea v-if="quotationForm.show_line_item_description" row="3" class="not-rounded muted-background p2 darkblue gibson line-height-4 border-none col-12" v-model="row.description" placeholder="Desc" name="description" style="font-size:1rem;"></autosize-textarea>
                              </td>
                              <!-- extra row type -->
                              <td class="typecell">
                                <b-form-select v-model="row.type" :options="dataStatus" class="muted-background darkblue border-none not-rounded col-12" style="font-size:1rem;height:48px;"></b-form-select>
                              </td>
                              <!-- extra row quantity -->
                              <td v-show="show_quantity" class="quantitycell">
                                <input type="text" class="muted-background darkblue p2 border-none not-rounded h6 mb2 col-12" :name="'item_quantity_'+index" v-model="row.quantity" placeholder="Quantity" required @change="calculate">
                              </td>
                              <!-- extra row price -->
                              <td v-show="quotationForm.show_line_item_tax" class="pricecell">
                                <input type="text" class="muted-background darkblue p2 border-none not-rounded h6 mb2 col-12" :name="'item_unit_price_'+index" v-model="row.unitPrice" placeholder="Unit Price" required @change="calculate">
                              </td>
                              <!-- extra row amount -->
                              <td class="amountcell">
                                <span class="block p2 regular muted-background line-height-1 flex justify-end items-center col-12" style="height:48px;">{{row.amount}} kr</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- billing table setup -->
                        <div class="clearfix">
                          <table class="table">
                            <tbody>
                              <tr class="col-12 px0">
                                <td class="col-12 px0">
                                  <div class="col-12 px0 flex justify-between items-center">
                                    <p class="h5 darkblue gibson line-height-1">
                                      Sub Total (DKK)
                                    </p>
                                    <p class="h5 darkblue gibson line-height-1">
                                      {{quotationForm.subtotal}}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                              <tr class="col-12 px0">
                                <td class="col-12 px0">
                                  <!-- discount setup -->
                                  <div class="col-12 px0 flex justify-between items-center">
                                    <div class="flex-auto">
                                      <p class="h5 darkblue gibson line-height-1">
                                        <span class="inline-block">
                                          Discount
                                        </span>
                                        <template>
                                          <span v-if="quotationForm.subtotalDiscount_type">(%)</span>
                                          <span v-else>(DKK)</span>
                                        </template>
                                      </p>
                                      <div class="checkbox mediumgrey h5 line-height-1">
                                        <input name="subtotalDiscount_type" type="checkbox" value="1" id="subtotalDiscount_type" v-model="quotationForm.subtotalDiscount_type" @change="calculate">
                                        <label for="subtotalDiscount_type">in % ?</label>
                                      </div>
                                    </div>
                                    <div class="flex-none">
                                      <input style="text-align:right;" class="darkblue h5 p0 border-none not-rounded quotation-input" name="subtotalDiscount" v-model="quotationForm.subtotalDiscount" placeholder="Discount" @change="calculate">
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr class="col-12 px0">
                                <!-- tax setup -->
                                <td class="col-12 px0">
                                  <div class="col-12 px0 flex justify-between items-center">
                                    <p class="h5 darkblue gibson line-height-1">Tax (%)</p>
                                    <p class="h5 darkblue gibson line-height-1" style="text-align:right;">{{quotationForm.subtotal_tax}}</p>
                                  </div>
                                </td>
                              </tr>
                              <tr class="col-12 px0">
                                <td class="col-12 px0">
                                  <div class="col-12 px0 flex justify-between items-center">
                                    <p class="h5 darkblue gibson line-height-1">
                                      Total (DKK)
                                    </p>
                                    <p class="h5 darkblue gibson line-height-1" style="text-align:right;">
                                    <span v-if="quotationForm.total < 0" class="semi-bold red">
                                      {{quotationForm.total}}
                                    </span>
                                    <span v-else>
                                      {{quotationForm.total}}
                                    </span>
                                  </p>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                      <div class="clearfix">
                        <!-- save as draft setup -->
                        <div class="secondarycolor-background p2 saveDraftSetup">
                          <b-form-checkbox id="checkbox1" v-model="quotationForm.is_draft" value=1 unchecked-value=0 checked-value=1 class="px2 secondarycolor-background white flex justify-start items-center mb0">
                            <p class="h5 regular gibson line-height-1 mb0 ml2 relative">Save as draft</p>
                          </b-form-checkbox>
                        </div>
                        <div class="py2"></div>
                        <div class="flex justify-between items-center mb3">
                          <button type="button" class="outlined-primary-button p2 not-rounded gibson h5 flex justify-center items-center" href="#/alle-moeder">
                            <span class="mr1">
                              <i class="el-icon-back"></i>
                            </span>
                            <span class="regular">Cancel</span>
                          </button>
                          <button type="submit" class="action-button p2 gibson border-none not-rounded h5 flex justify-center items-center">
                            <span class="regular">Send tilbud</span>
                            <span class="ml1">
                              <i class="el-icon-right"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
        <!-- modal for tilbud view -->
        <b-modal v-b-modal.modal-xl lazy v-model="tilbudShow" size="lg" ref="tilbudModal">
          <div class="clearfix">
            <div>
              <div>
                <div>
                  <div class="col-12 px0" v-if="partner.image !== ''">
                    <img width="100"  :src="partner.image" />
                  </div>
                  <div class="col-12 px0">
                    <p class="pull-right text-right">
                      Reference Number: <strong>{{quotation.info.reference_number}}</strong> <br />
                      <span v-if="quotation.info.date">Dato: <strong>{{quotation.info.date | moment}}</strong> <br /></span>
                      <span v-if="quotation.info.date && quotation.info.expiry_date">Expire dato: <strong>{{quotation.info.expiry_date | moment}}</strong></span>
                    </p>
                  </div>
                  <div class="col-12 px0">
                    <h5>Company Information</h5>
                    <h6><strong>{{partner.company}}</strong></h6>
                    <p class="contact-info">CVR: <strong>{{partner.cvr}}</strong></p>
                    <p class="contact-info">Email: <strong>{{partner.email}}</strong></p>
                    <p class="contact-info" >Phone: <strong>{{partner.mobile}}</strong></p>
                    <p class="" >Address: <strong>{{partner.address}} {{partner.city}}</strong></p>
                  </div>
                  <div class="col-12 px0">
                    <div class="text-right"></div>
                    <h5 class="text-right">Kunde</h5>
                    <div class="pull-right text-right" >
                      <h6 class="text-strong"><strong>{{customer.firstname}} {{customer.lastname}}</strong></h6>
                      <p class="contact-info">Email: <strong>{{customer.email}}</strong></p>
                      <p class="contact-info" >Phone: <strong>{{customer.mobile}}</strong></p>
                      <p class="" >Address: <strong>{{customer.mailingstreet}} {{customer.mailingcity}}</strong></p>
                    </div>
                  </div>
                  <div class="col-12 px0" v-if="quotation.info.subject || quotation.info.description">
                    <h5 v-if="quotation.info.subject" v-text="quotation.info.subject"></h5>
                    <div v-if="quotation.info.description" v-html="quotation.info.description" style="text-align:justify;"></div>
                    <hr />
                  </div>
                  <div class="col-12 px0">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <td class="text-strong">#</td>
                            <td class="text-strong">Item</td>
                            <td class="text-strong text-left">Type</td>
                            <td class="text-strong text-left" >Quantitly</td>
                            <td class="text-strong text-left">Unit prcie(Dkk)</td>
                            <td class="text-strong text-right" style="width:150px;">Amount</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item,index) in quotation.info.rows">
                            <td v-text="index + 1"></td>
                            <td>
                              <span v-if="item.custom_name">{{item.custom_name}}</span>
                              <span v-else>{{item.description}}</span>
                            </td>
                            <td v-if="quotation.line_item_description" v-text="item.description"></td>
                            <b-form-select disabled   v-model="item.type" :options="dataStatus"  class="text-dark rounded border-0">
                            </b-form-select>
                          </td>
                          <td  class="text-right" v-text="item.quantity"></td>
                          <td class="text-right" v-text="formatNumber(item.unitPrice,2)"></td>
                          <td class="text-right" v-text="formatNumber(item.amount,2)"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-12 px0">
                  <div v-if="quotation.files.length !== 0">
                    <h5 class="card-title">Attachment</h5>
                    <ul style="list-style: none;padding: 0;" class="m-t-10">
                      <li v-for="attachment in quotation.files" :key="attachment.id">
                        <a><i class="el-icon-paperclip"></i>{{attachment}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-12 px0" style="margin-top: -17px;" >
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <td class="text-strong text-right">Subtotal (DKK)</td>
                        <td style="width:150px;" class="text-right" v-text="formatNumber(quotation.info.subtotal,2)"></td>
                      </tr>
                      <tr v-if="quotation.info.subtotal_discount">
                        <td class="text-strong text-right">Discount
                          <span v-if="quotation.info.subtotal_discount_type">(%)</span>
                          <span v-else>(DKK)</span>
                        </td>
                        <td class="text-right" v-text="formatNumber(quotation.info.subtotal_discount_amount,2)"></td>
                      </tr>
                      <tr v-if="quotation.info.subtotal_tax">
                        <td class="text-strong text-right">Tax (%)</td>
                        <td class="text-right" v-text="formatNumber(quotation.info.subtotalTax,2)"></td>
                      </tr>
                      <tr>
                        <td class="text-strong text-right">Total (DKK)</td>
                        <td class="text-strong text-right" v-text="formatNumber(quotation.info.total,2)"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-12 col-md-6">
                  <blockquote style="margin-top: 10px;" v-if="quotation.info.tnc">
                    <h6 class="card-title">Terms & Conditions:</h6>
                    {{quotation.info.tnc}}
                  </blockquote>
                  <blockquote style="margin-top: 10px;" v-if="quotation.info.customer_note">
                    <h6 class="card-title">Customer Note:</h6>
                    {{quotation.info.customer_note}}
                  </blockquote>
                  <blockquote style="margin-top: 10px;" v-if="quotation.info.memo">
                    <h6 class="card-title">Memo:</h6>
                    {{quotation.info.memo}}
                  </blockquote>
                </div>
                <div class="col-12 col-md-6 pull-right" style="margin-top: -17px;" v-if="quotation.quotation_item">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <td class="text-strong text-right">{{trans('quotation.subtotal')}} ({{quotation.currency.symbol}})</td>
                        <td style="width:150px;" class="text-right" v-text="formatNumber(quotation.subtotal,quotation.currency.decimal_place)"></td>
                      </tr>
                      <tr v-if="quotation.subtotal_discount">
                        <td class="text-strong text-right">{{trans('quotation.subtotal_discount')}}
                          <span v-if="quotation.subtotal_discount_type">(%)</span>
                          <span v-else>({{quotation.currency.symbol}})</span>
                        </td>
                        <td class="text-right" v-text="formatNumber(quotation.subtotal_discount_amount,getConfig('quotation_subtotal_discount_decimal_place'))"></td>
                      </tr>
                      <tr v-if="quotation.subtotal_tax">
                        <td class="text-strong text-right">{{trans('quotation.subtotal_tax')}} (%)</td>
                        <td class="text-right" v-text="formatNumber(quotation.subtotal_tax_amount,getConfig('quotation_subtotal_tax_decimal_place'))"></td>
                      </tr>
                      <tr v-if="quotation.subtotal_shipping_and_handling">
                        <td class="text-strong text-right">{{trans('quotation.subtotal_shipping_and_handling')}} ({{quotation.currency.symbol}})</td>
                        <td class="text-right" v-text="formatNumber(quotation.subtotal_shipping_and_handling_amount,getConfig('quotation_subtotal_shipping_and_handling_decimal_place'))"></td>
                      </tr>
                      <tr>
                        <td class="text-strong text-right">{{trans('quotation.total')}} ({{quotation.currency.symbol}})</td>
                        <td class="text-strong text-right" v-text="formatNumber(quotation.total,quotation.currency.decimal_place)"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div slot="modal-footer" class="py-4 pl-2 pr-2 d-flex justify-content-end w-100">
            <b-col cols="6" class="pl-0">
              <b-btn type="buttom" slot="modal-cancel" variant="secondary"  class="float-left rounded" @click="hideModal">
                <i class="el-icon-error"></i>Luk
              </b-btn>
            </b-col>
          </div>
        </b-modal>
        <loading :show="show" :label="label" :overlay="overlay"></loading>
        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      </div>
      <!-- mobile setup -->
      <div class="px2" v-if="showMobile">
        <!-- reference table -->
        <div class="clearfix pl2">
          <!-- all tilbud header -->
          <div class="mb2">
            <p class="hide h6 regular darkblue line-height-4 gibson">
              Alle tilbud
            </p>
            <div class="flex justify-end items-end">
              <button v-b-toggle.archive class="outlined-action-button p1 px2 flex justify-start items-center">
                <span class="when-closed">
                  <span class="relative">
                    <i class="h5 line-height-1 mb0 el-icon-folder"></i>
                  </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative">
                    <i class="h5 line-height-1 mb0 el-icon-folder-opened"></i>
                  </span>
                </span>
                <p class="h6 semi-bold line-height-1 mb0 ml1">
                  Archive
                </p>
              </button>
            </div>
            <b-collapse id="archive" class="pb2">
              <!-- new mobile alle tilbud layout -->
              <template>
                <div v-if="quotations.length === 0 ">
                  <div class="flex justify-center items-center">
                    No items
                  </div>
                </div>
                <div v-else class="p2 border-none shadow mb3" v-for="quotation in quotations" :key="quotation.id">
                  <!-- {{quotation}} -->
                  <!-- mobile ref number -->
                  <div class="flex flex-column mb2">
                    <span class="h6 darkblue light line-height-1">Ref number</span>
                    <span class="h5 regular line-height-1 m0 gibson" v-if="quotation.info.reference_number">{{quotation.info.reference_number}}</span>
                  </div>
                  <!-- mobile tilbud name -->
                  <div class="flex flex-column mb2">
                    <span class="h6 darkblue light line-height-1">Navn</span>
                    <template>
                      <span class="h5 regular line-height-1 m0 gibson" v-if="quotation.name">{{quotation.name}}</span>
                      <span class="h5 regular line-height-1 m0 gibson" v-else>&nbsp;</span>
                    </template>
                  </div>
                  <!-- mobile date -->
                  <div class="flex flex-column mb2">
                    <div class="col-12 px0 flex justify-between items-center">
                      <div class="flex flex-column">
                        <span class="h6 darkblue light line-height-1">Dato sendt</span>
                        <span class="regular line-height-1 m0 gibson" v-if="quotation.info.date">{{quotation.info.date || moment}}</span>
                      </div>
                      <div class="flex flex-column">
                        <span class="h6 darkblue light line-height-1">Udløbsdate</span>
                        <span class="regular line-height-1 m0 gibson expireTableHeader block" v-if="quotation.info.expiry_date">{{quotation.info.expiry_date || moment}}</span>
                      </div>
                    </div>
                  </div>
                  <!-- mobile tilbud status -->
                  <div class="hide flex flex-column">
                    <span class="h6 darkblue light line-height-1">Tilbud sendt</span>
                    <template>
                      <span class="regular line-height-1 m0 gibson" v-if="quotation.sent == '0'">Nej</span>
                      <span class="regular line-height-1 m0 gibson" v-else>Ja</span>
                    </template>
                  </div>
                  <!-- mobile project status -->
                  <div class="flex flex-column mb2">
                    <span class="h6 darkblue light line-height-1">Status</span>
                    <span class="h6 regular line-height-1 m0 gibson dateTableHeader block">
                      <span class="yellow-background darkblue regular inline-block" v-if="quotation.is_draft === '1'">Draft</span>
                      <span class="lightgrey-background flex justify-center items-center py1 darkblue regular inline-block" v-if="quotation.condition === '1'">
                        <span clas="inline-block">
                          <i class="el-icon-time"></i>
                        </span>
                        <span class="pl1 inline-block regular mb0">
                          Afventer
                        </span>
                      </span>
                    </span>
                  </div>
                  <!-- mobile tilbud actions -->
                  <div>
                    <span class="h6 mb1 darkblue light line-height-1">Actions</span>
                  </div>
                  <div class="flex flex-wrap">
                    <button class="mb1 dark-button line-height-1 p2 flex justify-start items-center gibson border-none mr1" @click="showItemDetails(quotation)">
                      <span class="regular mb0 mr2">
                        Vis tilbuddet
                      </span>
                      <span>
                        <i class="el-icon-right"></i>
                      </span>
                    </button>
                    <button class="mb1 action-button line-height-1 p2 flex justify-start items-center gibson border-none mr1">
                      <span class="regular mb0 mr2">
                        Send
                      </span>
                      <span>
                        <i class="el-icon-right"></i>
                      </span>
                    </button>
                    <button class="mb1 warning-button line-height-1 p2 flex justify-start items-center gibson mr1" tooltip="Edit" @click.prevent="editQuotation(quotation)">
                      <span class="regular mb0 mr2">
                        Edit
                      </span>
                      <span>
                        <i class="el-icon-edit"></i>
                      </span>
                    </button>
                    <button class="mb1 delete-action-button line-height-1 border-none flex justify-start items-center gibson px2 py1" :key="quotation.id" v-confirm="{ok: confirmDelete(quotation)}" tooltip="Slet">
                      <i class="el-icon-delete"></i>
                    </button>
                  </div>
                </div>
              </template>
            </b-collapse>
          </div>
          <!-- mobile alle tilbud table -->
          <div class="hide table-responsive" striped bordered>
            <table class="table">
              <thead class="hide">
                <tr>
                  <th class="addressTableHeader">
                    <span class="h6 inline-block semi-bold line-height-1 m0 gibson addressTableHeader">Adresse</span>
                  </th>
                  <th class="">
                    <span class="h6 inline-block semi-bold line-height-1 m0 gibson dateTableHeader">Date sent</span>
                  </th>
                  <th>
                    <span class="h6 inline-block semi-bold line-height-1 m0 gibson statusTableHeader">Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="quotation in quotations" :key="quotation.id">
                  <td>
                    <span class="semi-bold line-height-1 m0 gibson" v-if="quotation.info.reference_number">{{quotation.info.reference_number}}</span>
                  </td>
                  <td>
                    <span class="regular line-height-1 m0 gibson" v-if="quotation.name">{{quotation.name}}</span>
                  </td>
                  <td class="dateTableHeader">
                    <span class="regular line-height-1 m0 gibson" v-if="quotation.info.date">{{quotation.info.date || moment}}</span>
                  </td>
                  <td>
                    <span class="regular line-height-1 m0 gibson expireTableHeader block" v-if="quotation.info.expiry_date">{{quotation.info.expiry_date || moment}}</span>
                  </td>
                  <td>
                    <template>
                      <div class="flex justify-center items-center">
                        <span class="regular line-height-1 m0 gibson" v-if="quotation.sent == '0'">Nej</span>
                        <span class="regular line-height-1 m0 gibson" v-else>Ja</span>
                      </div>
                    </template>
                  </td>
                  <td>
                    <span class="h6 regular line-height-1 m0 gibson dateTableHeader block">
                      <span class="yellow-background darkblue regular inline-block" v-if="quotation.is_draft === '1'">Draft</span>
                      <span class="more-muted-background darkblue regular inline-block" v-if="quotation.condition === '1'">
                        <span>
                          <i class="el-icon-time"></i>
                        </span>
                        <span class="regular mb0 mr2">
                          Afventer
                        </span>
                      </span>
                    </span>
                  </td>
                  <td class="table-option text-center">
                    <div class="btn-group">
                      <button class="dark-button line-height-1 p1 flex justify-start items-center gibson border-none mr1" @click="showItemDetails(quotation)">
                        <span class="regular mb0 mr2" style="font-size:75%">
                          View
                        </span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="action-button line-height-1 p1 flex justify-start items-center gibson border-none mr1">
                        <span class="regular mb0 mr2" style="font-size:75%">
                          Send
                        </span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="warning-button line-height-1 p1 flex justify-start items-center gibson mr1" tooltip="Edit" @click.prevent="editQuotation(quotation)">
                        <span class="regular mb0 mr2" style="font-size:75%">
                          Edit
                        </span>
                        <span>
                          <i class="el-icon-edit"></i>
                        </span>
                      </button>
                      <button class="delete-action-button line-height-1 border-none flex justify-start items-center gibson px2 py1" :key="quotation.id" v-confirm="{ok: confirmDelete(quotation)}" tooltip="Slet">
                        <i class="el-icon-delete"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- single tilbud -->
        <div class="clearfix border muted-border p2 px3 pb3 mb2 shadow">
          <div>
            <!-- title - header - text -->
            <p class="h6 gibson regular line-height-2 mt2 mb1">Tilbud</p>
            <p class="h4 semi-bold darkblue gibson line-height-golden mb1">{{customer.firstname}} {{customer.lastname}}</p>
            <ol class="breadcrumb list-reset border-none mb0">
              <li class="breadcrumb-item h5 gibson">
                <router-link to="/alle-moeder">Alle møder</router-link>
              </li>
              <li class="breadcrumb-item h5 gibson active">Tilbud</li>
            </ol>
            <p class="h5 darkblue regular line-height-golden mb2 px0">
              Her har vi samlet informationerne omkring dit partnerskab. Portalen giver dig blandt andet følgende muligheder:
            </p>
            <!-- mobile customer information button -->
            <div class="px0">
              <button v-b-toggle.collapse2 class="col-12 px0 white-button p1 flex justify-between items-center gibson">
                <p class="h5 semi-bold line-height-1 mb0">
                  Kundeinfo
                </p>
                <span class="when-closed">
                  <span class="relative">
                    <svg fil="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>                    </span>
                  </span>
                <span class="flex-none when-opened">
                  <span class="relative">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- mobile customer information collapse -->
            <b-collapse id="collapse2" class="mt2">
              <div class="clearfix">
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Navn :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{customer.firstname}} {{customer.lastname}}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Email :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{customer.email}}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Mobile :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{customer.mobile}}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Adresse :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson">{{ customer.mailingstreet }} {{ customer.mailingzip }} {{ customer.mailingcity }}</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Mødedato :</p>
                  <p class="h5 semi-bold darkblue line-height-3 gibson" v-if="app.hentilbud === 0">{{moment(app.appointment_date).locale('da').format('LL')}}<br>kl. {{app.id_times}} </p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Prisen er inkl. moms :</p>
                  <p class="h5 semi-bold darkblue line-height-1 gibson" v-if="app.hentilbud === 0">{{customer.lowamountmoms}} - {{customer.highamountmoms}} kr.</p>
                </div>
                <div class="col-12 px1 mb2">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Kommentarer</p>
                  <p class="h5 regular darkblue line-height-4 gibson" v-if="app.hentilbud === 0">{{app.comment_to_partner}}</p>
                </div>
                <div class="col-12 px1" v-if="customer.files.length !== 0">
                  <p class="line-height-1 mb1 h6 darkblue gibson">Filer</p>
                  <ul style="list-style: none;padding: 0;" class="m-t-10">
                    <li v-for="attachment in customer.files" :key="attachment.id" class="py-1">
                      <a :href="attachment" ><i class="el-icon-paperclip"></i> {{attachment.substring(attachment.lastIndexOf('/')+1)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </b-collapse>
            <!-- mobile opgavens indhold button -->
            <div class="px0 flex justify-between items-center">
              <button v-b-toggle.collapse3 class="col-12 px0 white-button p1 flex justify-between items-center gibson">
                <p class="h5 semi-bold line-height-1 mb0">
                  Opgavens indhold
                </p>
                <span class="when-closed">
                  <span class="relative">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>                    </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- mobile opgavens indhold collapse -->
            <b-collapse id="collapse3" class="mt2">
              <div class="clearfix">
                <div class="col-6 px0">
                  <b-table striped hover :items="items" class="mb4"></b-table>
                </div>
              </div>
            </b-collapse>
            <!-- mobile pictures button -->
            <div class="px0 flex justify-between items-center">
              <button v-b-toggle.collapse4 class="col-12 px0 white-button p1 flex justify-between items-center gibson">
                <p class="h5 semi-bold line-height-1 mb0">
                  Billeder
                </p>
                <span class="when-closed">
                  <span class="relative">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>                    </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- mobile pictures collapse -->
            <b-collapse id="collapse4" class="mt2">
              <div class="flex flex-wrap">
                <div class="col-12 px0" style="height:120px;" v-for="(image, i) in images" @click="onClick(i)" :key="image.id">
                  <img class="fit" :src="image">
                  <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
                </div>
              </div>
            </b-collapse>
            <!-- mobile kom i hang button -->
            <div class="px0 my2">
              <button class="col-12 not-rounded action-button gibson p2 h4 flex justify-center items-center line-height-1" ref="addt" @click="newCreatorShow = true" name="moretilbud">
                <span class="semi-bold gibson">Kom i gang</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <!-- old offer creator -->
            <div class="hide col-12 px0">
              
            </div>
          </div>
        </div>
        <!-- new offer creator modal setup -->
        <b-modal size="xl" v-b-modal lazy v-model="newCreatorShow" id="moretilbud">
          <div class="clearfix px1">
            <div @click="newCreatorShow = false" class="col-12 px0 flex justify-start items-center">
              <span class="h3 darkblue regular line-height-1 mb0 p0"><i class="el-icon-back"></i></span>
              <span class="h5 darkblue semi-bold line-height-1 mb0 ml1">Opret tilbud</span>
            </div>
            <div class="col-12 my2 px0">
              <p class="h5 darkblue regular line-height-3">
                Her kan du oprette et udkast på dit tilbud, og sende til kunden. Tilføj indholdet ved at udfylde de angivne informationer.
              </p>
            </div>
          </div>
          <!-- wizard for mobile -->
          <div class="clearfix">
            <div class="clearfix my3">
              <div class="col col-4">
                <div class="green-background" style="height:3px;"></div>
              </div>
              <div class="col col-4">
                <div class="lightgrey-background" style="height:3px;"></div>
              </div>
              <div class="col col-4">
                <div class="lightgrey-background" style="height:3px;"></div>
              </div>
            </div>
            <div class="clearfix"></div>
            <form-wizard>
              <!-- wizard first step -->
              <tab-content title="">
                <!-- add header and image for mobile -->
                <div class="clearfix py2 border muted-border mb2">
                  <button v-b-toggle.addHeader class="col-12 pr2 white-button flex justify-between items-center gibson">
                    <div class="flex justify-start items-start px2">
                      <img src="static/svg/picture-primarycolor.svg" width="36" height="36" alt="">
                      <p class="h5 darkblue line-height-3 mb0 pl2">
                        <span class="regular block left">Tilføj oversktift</span>
                        <span class="h6 block light left">Sample Header Here</span>
                      </p>
                    </div>
                    <span class="when-closed">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                  <b-collapse id="addHeader" class="mt2 px2">
                    <div class="clearfix pt2">
                      <div class="col-12 px0">
                        <p class="h5 darkblue semi-bold line-height-1 mb1">
                          Overskrift
                        </p>
                        <input type="text" placeholder="Din overskrift" class="h5 col-12 p2 lightgrey-background darkblue line-height-1 border-none">
                        <div class="my1">
                          <el-upload class="col-12 px0" drag action="https://www.kundematch.dk/customerService.php" multiple style="border: 1px dashed rgb(25, 163, 192);">
                            <div class="col-12 px2 flex flex-column justify-center items-center py3">
                              <img src="static/svg/picture-primarycolor.svg" width="48"/>
                              <span class="h5 mt2 el-upload__text primarycolor regular line-height-3 px2">Tilføj billeder til tilbuddet</span>
                            </div>
                          </el-upload>
                        </div>
                        <div class="py1"></div>
                        <button class="standard-button p2 px3 line-height-1 h4 semi-bold right">Gem</button>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- add item -->
                <div class="clearfix py2 border muted-border mb2">
                  <button v-b-toggle.addItem class="col-12 pr2 white-button flex justify-between items-center gibson">
                    <div class="flex justify-start items-center px2">
                      <img src="static/svg/mobile.svg" width="36" height="36" alt="">
                      <p class="h5 darkblue line-height-3 mb0 pl2">
                        <span class="regular block">Tilføj enhed</span>
                      </p>
                    </div>
                    <span class="when-closed">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                  <!-- completed item layout -->
                  <div class="col-12 mt2">
                    <div class="clearfix">
                      <div class="col-12 px0 py1 flex justify-between items-center border-top border-bottom muted-border mb2" style="border-left-color: white;border-right-color: white;">
                        <span>
                          <span class="mr1"><i class="h4 primarycolor el-icon-edit"></i></span>
                          <span class="h6 darkblue regular mb0">Item Name</span>
                        </span>
                        <span class="h6 darkblue light mb0">2,00 kr</span>
                      </div>
                      <div class="col-12 px0 flex justify-between items-center">
                        <span class="h6 darkblue regular">Subtotal</span>
                        <span class="h6 darkblue light">2,00 kr</span>
                      </div>
                      <div class="col-12 px0 flex justify-between items-center">
                        <span class="h6 darkblue regular">MOMS</span>
                        <span class="h6 darkblue light">0,00 kr</span>
                      </div>
                      <div class="col-12 px0 flex justify-between items-center">
                        <span class="h6 primarycolor regular line-height-1">Total</span>
                        <span class="h6 darkblue light">0,00 kr</span>
                      </div>
                    </div>
                  </div>
                  <b-collapse id="addItem" class="mt2 px2">
                    <div class="clearfix pt2">
                      <div class="col-12 px0">
                        <textarea name="" id="" placeholder="Navn på enhed" rows="2" class="h5 col-12 p2 white-background darkblue line-height-1 border muted-border"></textarea>
                        <div class="col-12 px0 mb2">
                          <p class="h6 darkblue semi-bold line-height-1 mb1">Antal</p>
                          <input type="text" placeholder="" class="col-12 p1 border muted-border darkblue">
                        </div>
                        <div class="col-12 px0 mb2">
                          <p class="h6 darkblue semi-bold line-height-1 mb1">Type</p>
                          <input type="text" placeholder="" class="col-12 p1 border muted-border darkblue">
                        </div>
                        <div class="col-12 px0 mb2">
                          <p class="h6 darkblue semi-bold line-height-1 mb1">Pris</p>
                          <input type="text" placeholder="" class="col-12 p1 border muted-border darkblue">
                        </div>
                        <div class="col-12 px0 mb2">
                          <p class="h6 darkblue semi-bold line-height-1 mb1">Total</p>
                          <input type="text" placeholder="" class="col-12 p1 border muted-border darkblue">
                        </div>
                        <button class="standard-button p2 px3 line-height-1 h4 semi-bold right">Gem</button>
                      </div>
                      
                    </div>
                  </b-collapse>
                </div>
                <!-- add discount-->
                <div class="clearfix py2 border muted-border mb2">
                  <button v-b-toggle.addDiscount class="col-12 pr2 white-button flex justify-between items-center gibson">
                    <div class="flex justify-start items-center px2">
                      <img src="static/svg/verified-document.svg" width="36" height="36" alt="">
                      <p class="h5 darkblue line-height-3 mb0 pl2">
                        <span class="regular block">Tilføj rabat</span>
                      </p>
                    </div>
                    <span class="when-closed">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                  <b-collapse id="addDiscount" class="mt2">
                    <div class="clearfix pt2">
                      <div class="clearfix flex justify-start items-start px0 mb2">
                        <div class="col col-5 pr2 pl2">
                          <div class="green-background p2 white flex justify-center items-center">
                            <p class="h5 semi-bold line-height-1 mb0">Beløb</p>
                          </div>
                        </div>
                        <div class="col col-7 px0 pr2 pl0">
                          <div class="lightgrey-background p2 flex justify-start items-center">
                            <input type="text" class="h5 regular line-height-1 border-none" style="text-align:right;background-color:transparent;margin-bottom:0!important;width:100px;padding-right:8px;" placeholder="0,00">
                            <span class="h5 caps line-height-1 mb0">DKK</span>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix flex justify-start items-start px0 mb2">
                        <div class="col col-5 pr2 pl2">
                          <div class="border green-border green p2 flex justify-center items-center">
                            <p class="h5 semi-bold line-height-1 mb0">Procent</p>
                          </div>
                        </div>
                        <div class="col col-7 px0 pr2 pl0">
                          <div class="lightgrey-background p2 flex justify-start items-center">
                            <input type="text" class="h5 regular line-height-1 border-none" style="text-align:right;background-color:transparent;margin-bottom:0!important;width:100px;padding-right:8px;" placeholder="0.00">
                            <span class="h5 semi-bold caps line-height-1 mb0">%</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <button class="standard-button p2 px3 line-height-1 h4 semi-bold right">Gem</button>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- add customer-->
                <div class="clearfix py2 border muted-border mb2">
                  <button v-b-toggle.addCustomer class="col-12 pr2 white-button flex justify-between items-center gibson">
                    <div class="flex justify-start items-center px2">
                      <img src="static/svg/handshake.svg" width="36" height="36" alt="">
                      <p class="h5 darkblue line-height-3 mb0 pl2">
                        <span class="regular block left">Tilføj kunde</span>
                        <span class="h6 block light left">Sample Name Here</span>
                      </p>
                    </div>
                    <span class="when-closed">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                  <b-collapse id="addCustomer" class="mt2 px2">
                    <div class="clearfix pt2">
                      <div class="clearfix">
                        <div class="col col-6 pr2 pl0">
                          <div class="col-12 p2 green-background center white line-height-1">
                            <span class="h5 regular mb0">Kunde</span>
                          </div>
                        </div>
                        <div class="col col-6 px0">
                          <div class="col-12 p2 border darkblue-border center darkblue line-height-1">
                            <span class="h5 regular mb0">Kontakt</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 flex flex-column mt2 px0">
                        <input type="text" placeholder="Navn" class="h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2">
                        <input type="text" placeholder="Email" class="h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2">
                        <input type="text" placeholder="Mobil" class="h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2">
                        <input type="address" placeholder="Adresse" class="h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2">
                      </div>
                      <div class="col-12 flex justify-between items-center px0 mb2">
                        <span class="col-5 flex-auto h6 darkblue line-height-1 mb0 px2 py1">Dato</span>
                        <div class="py1 lightgrey-background flex justify-between items-center">
                          <datepicker v-model="quotationForm.date" :bootstrapStyling="true" placeholder="Dato" :language="da" class="darkblue gibson border-none not-rounded"></datepicker>
                          <button class="border-none flex justify-center items-center line-height-1 darkblue" style="background:transparent;">
                            <span>
                              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-trash"><path d='M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zm10 2H2v1h14V4zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7h-9.72zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z'/></svg>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div class="col-12 flex justify-between items-center px0 mb2">
                        <span class="col-5 flex-auto h6 darkblue line-height-1 mb0 px2 py1">Udløbsdato</span>
                        <div class="py1 lightgrey-background flex justify-between items-center">
                          <datepicker v-model="quotationForm.date" :bootstrapStyling="true" placeholder="Dato" :language="da" class="darkblue gibson border-none not-rounded"></datepicker>
                          <button class="border-none flex justify-center items-center line-height-1 darkblue" style="background:transparent;">
                            <span>
                              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt-f"><path d='M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z' /></svg>
                            </span>
                          </button>
                        </div>
                        
                      </div>
                      <div class="col-12 flex justify-between items-center px0 mb2">
                        <textarea name="" id="" rows="2" class="h5 col-12 lightgrey-background border-none p2 darkblue line-height-4 mb2" placeholder="Kommentar" style="resize:none;"></textarea>
                      </div>
                      <div class="col-12 px0">
                        <button class="standard-button p2 px3 line-height-1 h4 semi-bold right">Gem</button>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- add conditions-->
                <div class="clearfix py2 border muted-border mb2">
                  <button v-b-toggle.addConditions class="col-12 pr2 white-button flex justify-between items-center gibson">
                    <div class="flex justify-start items-center px2">
                      <img src="static/svg/documents-blue.svg" width="36" height="36" alt="">
                      <p class="h5 darkblue line-height-3 mb0 pl2">
                        <span class="regular block">Tilføj betingelser</span>
                      </p>
                    </div>
                    <span class="when-closed">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
                      </span>
                    </span>
                    <span class="flex-none when-opened">
                      <span class="relative" style="top:3px;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </span>
                  </button>
                  <b-collapse id="addConditions" class="mt2 px2">
                    <div class="clearfix pt2">
                      <div class="col-12 px0 flex flex-column mb2">
                        <p class="h6 darkblue regular line-height-1 mb1">
                          Standardnoter
                        </p>
                        <textarea name="" id="" class="lightgrey-background p2 h6 line-height-3 border-none regular" readonly style="min-height:180px;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur alias dolorum culpa perspiciatis deserunt voluptates sapiente voluptatum temporibus, obcaecati suscipit ratione fugiat! Est ullam aspernatur libero? Modi corporis illum obcaecati.</textarea>
                      </div>
                      <div class="col-12 px0 flex flex-column mb2">
                        <p class="h6 darkblue regular line-height-1 mb1">
                          Brugerdefinerede noter
                        </p>
                        <div class="my1">
                          <el-upload class="col-12 px0 py2" drag action="https://www.kundematch.dk/customerService.php" multiple style="border: 1px dashed rgb(25, 163, 192);">
                            <div class="col-12 mt1 px2 flex flex-column justify-center items-center">
                              <img src="static/svg/picture-primarycolor.svg" width="48"/>
                              <span class="h5 mt2 mb0 el-upload__text primarycolor regular line-height-3 px2">Tilføj dine noter her</span>
                            </div>
                          </el-upload>
                        </div>
                      </div>
                      <div class="col-12 px0">
                        <button class="standard-button p2 px3 line-height-1 h4 semi-bold right">Gem</button>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </tab-content>
              <!-- wizard second step -->
              <tab-content title="">
                <div class="clearfix">
                  <div class="col-12 mb3">
                    <span class="block h5 darkblue semi-bold line-height-3 mb0">
                      Vis dine anbefalinger frem på dit tilbud:
                    </span>
                    <span class="mt3 block h5 line-height-1 mb0 flex justify-between items-start">
                      <span class="darkblue regular">Udvalgte anbefalinger:</span>
                      <span class="primarycolor semi-bold">0 / 5</span>
                    </span>
                  </div>
                  <div class="col-12 flex flex-column">
                    <div class="p2 border muted-border shadow mb3">
                      <div class="col-12 px0 flex justify-between items-start">
                        <div>
                          <image-rating src="/static/svg/single-house.svg" :rating="4.5" :max-rating="5" :increment="0.5" :item-size="22" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                        </div>
                        <div>
                          <input type="checkbox" style="height:18px;width:18px;">
                        </div>
                      </div>
                      <div class="mb2">
                        <span class="h5 darkblue regular line-height-1 mb0">review.date</span>
                      </div>
                      <div>
                        <p class="h5 darkblue regular line-height-2">review.author</p>
                      </div>
                      <div>
                        <p class="h6 darkblue light line-height-3">
                          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsum inventore, molestias eligendi ipsa...
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </tab-content>
              <!-- wizard last step -->
              <tab-content title="">
                <div class="clearfix py3">
                  <div class="col-12 px0 flex flex-column justify-center items-center">
                    <div class="my2">
                      <img src="static/svg/curriculum.svg" width="96" alt="">
                    </div>
                    <p class="h3 center primarycolor semi-bold line-height-3 mb1">Du er der næsten!</p>
                    <p class="h5 darkblue regular line-height-3 mb3 center">Gennemgå dit tilbud ved at klikke på Forhåndsvisning</p>
                    <button class="standard-button p2 flex justify-center items-center line-height-1">
                      <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="icon__icon"><path d="M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-3zm0-2V7a2 2 0 0 1 2-2h2V2H2v11h4zm8.172-6H8v11h8V8.828L14.172 7z"></path></svg></span>
                      <span class="h5">Forhåndsvisning</span>
                    </button>
                  </div>
                </div>
              </tab-content>
              <template slot="footer" slot-scope="props">
                <div class="col-12 px0 flex justify-between items-center my2">
                  <div>
                    <wizard-button @click.native="props.prevTab()" class="regular outlined-action-button border green-border line-height-1 flex-auto justify-start items-center inline-block not-rounded" style="padding:1rem!important;font-size:16px!important;">
                      <span><i class="el-icon-back"></i></span>
                      <span class="ml1">Tilbage</span>
                    </wizard-button>
                    <!-- <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" :style="props.fillButtonStyle">Previous</wizard-button> -->
                  </div>
                  <div>
                    <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.nextTab()" class="regular action-button line-height-1 flex-auto justify-center items-center inline-block not-rounded" style="padding:1rem!important;font-size:16px!important;background-color:rgba(77, 207, 85, 1.0)!important">
                      <span class="mr1">Fortsæt</span>
                      <span><i class="el-icon-right"></i></span>
                    </wizard-button>
                    
                    <wizard-button @click.native="props.nextTab()" type="button" v-else class="regular action-button line-height-1 flex-auto justify-center items-center inline-block not-rounded" style="padding:1rem!important;font-size:16px!important;background-color:rgba(77, 207, 85, 1.0)!important">
                      <span class="mr1">{{props.isLastStep ? 'Send tilbud' : 'Næste'}}</span>
                      <span><i class="el-icon-right"></i></span>
                    </wizard-button>
                  </div>
                </div>
              </template>
            </form-wizard>
          </div>
          <div class="clearfix my3">
            <form @submit="onSubmitTilbud" @reset="resetForm">
              <div class="clearfix">
                <!-- main form for creator -->
                <div class="col-12 px0">
                  <!-- offer creator logo upload -->
                  <div class="clearfix my2">
                    <!-- logo label -->
                    <p class="h6 regular darkblue gibson line-height-1">Logo</p>
                    <div v-if="!image" class="my2">
                      <input type="file" @change="onFileChange" class="col-12 muted-background darkblue gibson h5 p2">
                    </div>
                    <div v-else class="my2">
                      <div class="flex justify-between items-start">
                        <img width="80" :src="image" class="mb2 fit" />
                        <button class="not-rounded delete-button p1 border-none" @click="removeImage">
                          <span>
                            <i class="el-icon-delete"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix mb2">
                    <file-upload-input :token="quotationForm.upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
                  </div>
                  <!-- reference number -->
                  <div class="clearfix mb2">
                    <!-- reference label -->
                    <p class="h6 regular darkblue gibson line-height-1">Reference #</p>
                    <input class="col-12 muted-background darkblue h5 p2 border-none not-rounded" type="text" value="" v-model="quotationForm.reference_number" name="reference_number" required placeholder="Reference #">
                  </div>
                  <!-- date -->
                  <div class="clearfix mb2">
                    <!-- date label -->
                    <p class="h6 regular darkblue gibson line-height-1">Dato</p>
                    <datepicker v-model="quotationForm.date" :bootstrapStyling="false" placeholder="Dato" :language="da" class="muted-background p2 darkblue gibson h5 border-none not-rounded"></datepicker>
                  </div>
                  <!-- expiry date -->
                  <div class="clearfix mb2">
                    <!-- expiry label -->
                    <p class="h6 regular darkblue gibson line-height-1">Udløbsdato</p>
                    <datepicker v-model="quotationForm.expiry_date" :bootstrapStyling="false" placeholder="Udløbsdato" :language="da" class="muted-background p2 darkblue gibson h5 border-none not-rounded"></datepicker>
                  </div>
                  <!-- subject -->
                  <div class="clearfix mb2">
                    <!-- subject label -->
                    <p class="h6 regular darkblue gibson line-height-1">Emne</p>
                    <autosize-textarea v-model="quotationForm.subject" rows="1" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="subject" required placeholder="Subject"></autosize-textarea>
                  </div>
                  <!-- description -->
                  <div class="clearfix mb2">
                    <!-- description label -->
                    <p class="h6 regular darkblue gibson line-height-1">Beskrivelse</p>
                    <autosize-textarea v-model="quotationForm.description" rows="5" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="description" placeholder="Desciption"></autosize-textarea>
                  </div>
                  <!-- default tac -->
                  <div class="clearfix mb2">
                    <!-- default tac label -->
                    <p class="h6 regular darkblue gibson line-height-1">Default: Vilkår og betingelser</p>
                    <autosize-textarea v-model="quotationForm.tnc" rows="3" name="tnc" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" placeholder="Display default obligatory terms and conditions here. Scrollable but not editable."></autosize-textarea>
                  </div>
                  <!-- custom tac -->
                  <div class="clearfix mt1 mb2">
                    <!-- custom tac label -->
                    <p class="h6 regular darkblue gibson line-height-1">Custom: Vilkår og betingelser</p>
                    <autosize-textarea v-model="quotationForm.tnc" rows="3" name="tnc" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" placeholder="Editable terms and conditions. Button should save text to send to customer "></autosize-textarea>
                    <button class="col-12 action-button p2 h5 border-none line-height-1 not-rounded flex justify-center items-center gibson mt1">
                      <span class="regular">Gem redigeret udgave</span>
                      <span class="ml2">
                        <i class="el-icon-right"></i>
                      </span>
                    </button>
                  </div>
                  <!-- customer notes -->
                  <div class="clearfix mb2">
                    <!-- customer notes label -->
                    <p class="h6 regular darkblue gibson line-height-1">Customer note</p>
                    <autosize-textarea v-model="quotationForm.customer_note" rows="3" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="customer_note" placeholder="Customer Note"></autosize-textarea>
                  </div>
                  <!-- memo  -->
                  <div class="clearfix">
                    <!-- memo label -->
                    <p class="h6 regular darkblue gibson line-height-1">Memo</p>
                    <autosize-textarea v-model="quotationForm.memo" rows="3" class="not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none" name="memo" placeholder="Memo"></autosize-textarea>
                  </div>
                </div>
                <!-- new add row button for modal -->
                <button class="dark-button col-12 p2 h4 regular flex justify-center items-center line-height-1" @click="offerModalShow = true" type="button">
                  <span>Tilføj items</span>
                  <span class="ml2">
                    <i class="el-icon-circle-plus"></i>
                  </span>
                </button>
                <b-modal class="offerModal" v-b-modal.modal-xl lazy v-model="offerModalShow" size="lg" ref="offerModal">
                  <div class="clearfix">
                    <!-- add row button -->
                    <button class="action-button p1 h4 regular flex justify-start items-center h6 line-height-1" @click="addRow" type="button">
                      <span class="">
                        <i class="el-icon-circle-plus-outline"></i>
                      </span>
                      <span>Tilføj item</span>
                    </button>
                    <div class="mt2 mb3">
                      <div class="flex flex-column" v-for="(row,index) in quotationForm.rows" :key="row.id">
                        <div>
                          <!-- extra row item -->
                          <div class="flex flex-column col-12 px0 mt2 mb3">
                            <p class="h6 darkblue regular line-height-1 mb1">
                              Titel og beskrivelse
                            </p>
                            <input type="text" class="muted-background darkblue p2 border-none not-rounded h6 mb1 col-12" :name="'item_name_'+index" v-model="row.custom_name" required placeholder="Title">
                            <autosize-textarea v-if="quotationForm.show_line_item_description" row="8" class="not-rounded muted-background p2 darkblue gibson line-height-4 border-none col-12" v-model="row.description" placeholder="Desc" name="description" style="font-size:1rem;"></autosize-textarea>
                          </div>
                          <!-- extra row type -->
                          <div class="flex flex-column col-12 px0 mb3">
                            <p class="h6 darkblue regular line-height-1 mb1">
                              Type
                            </p>
                            <b-form-select v-model="row.type" :options="dataStatus" class="muted-background darkblue border-none not-rounded col-12 flex-none" style="font-size:1rem;height:48px;"></b-form-select>
                          </div>
                          <!-- extra row quantity -->
                          <div v-show="show_quantity" class="flex flex-column col-12 px0 mb3">
                            <p class="h6 darkblue regular line-height-1 mb1">
                              Quantity
                            </p>
                            <input type="text" class="muted-background darkblue p2 border-none not-rounded h6 mb2 col-12" :name="'item_quantity_'+index" v-model="row.quantity" placeholder="Quantity" required @change="calculate">
                          </div>
                          <!-- extra row price -->
                          <div v-show="quotationForm.show_line_item_tax" class="flex flex-column col-12 px0">
                            <p class="h6 darkblue regular line-height-1 mb1">
                              Pris
                            </p>
                            <input type="text" class="muted-background darkblue p2 border-none not-rounded h6 mb2 col-12" :name="'item_unit_price_'+index" v-model="row.unitPrice" placeholder="Unit Price" required @change="calculate">
                          </div>
                          <!-- extra row amount -->
                          <div class="flex flex-column col-12 px0">
                            <span class="block p2 regular muted-background line-height-1 flex justify-end items-center col-12" style="height:48px;">{{row.amount}} kr</span>
                          </div>
                          <div class="col-12 px0 flex justify-end items-center mt3">
                            <button class="delete-button p2 regular flex justify-start items-center h6 line-height-1 mr3" type="button" :key="row.uuid" v-confirm="{ok: confirmRowDelete(row)}" tooltip="Slet">
                              <i class="el-icon-delete"></i>
                              <span class="ml2">Slet</span>
                            </button>
                            <button class="action-button p2 regular flex justoify-center items-center h6 line-height-1">
                              <span class="mr2">Gem</span>
                              <span>
                                <i class="el-icon-right"></i>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div slot="modal-footer" style="display:none"></div> -->
                </b-modal>
                <div class="py1"></div>
                <div class="clearfix">
                  <!-- save as draft setup -->
                  <div class="secondarycolor-background p2 saveDraftSetup">
                    <b-form-checkbox id="checkbox1" v-model="quotationForm.is_draft" value=1 unchecked-value=0 checked-value=1 class="px2 secondarycolor-background white flex justify-start items-center mb0">
                      <p class="h5 regular gibson line-height-1 mb0 ml2 relative" style="top:-2px;">Save as draft</p>
                    </b-form-checkbox>
                  </div>
                  <div class="py2"></div>
                  <div class="flex justify-between items-center mb3">
                    <button type="button" class="outlined-primary-button p2 not-rounded gibson h5 flex justify-center items-center" href="#/alle-moeder">
                      <span class="mr1">
                        <i class="el-icon-back"></i>
                      </span>
                      <span class="regular">Cancel</span>
                    </button>
                    <button type="submit" class="action-button p2 gibson border-none not-rounded h5 flex justify-center items-center">
                      <span class="regular">Send tilbud</span>
                      <span class="ml1">
                        <i class="el-icon-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </b-modal>
        <!-- modal for tilbud view -->
        <b-modal v-b-modal lazy v-model="tilbudShow" ref="tilbudModal">
          <div class="clearfix">
            <div class="flex flex-column">
              <!-- modal partner name -->
              <div class="center mt3 mb2">
                <p class="h4 darkblue line-height-2 mb0">{{partner.company}}</p>
              </div>
              <!-- modal partner header image -->
              <div class="col-12 px0" v-if="partner.image !== ''">
                <!-- <img class="fit block" :src="partner.image" style="object-fit:fill;" /> -->
                <img class="fit block" src="static/img/forside_cover.jpg" alt="" style="object-fit:fill;">
              </div>
              <!-- modal tilbud details -->
              <div class="col-12 px0 mt2 center">
                <p class="h6 semi-bold line-height-2 darkblue gibson">
                  {{quotation.info.reference_number}}
                </p>
                <!-- dates sent and expire -->
                <div class="flex justify-between items-start my3">
                  <div>
                    <span class="block darkblue flex flex-column justify-start items-start">
                      <span class="h6 light line-height-1 mb1">Dato sendt</span>
                      <span class="semi-bold line-height-1">{{moment(quotation.info.date).locale('da').format('LL')}}</span>
                    </span>
                  </div>
                  <div>
                    <span class="block darkblue flex flex-column justify-start items-start">
                      <span class="h6 light line-height-1 mb1">Udløbsdato</span>
                      <span class="semi-bold line-height-1" v-if="quotation.info.date && quotation.info.expiry_date">{{moment(quotation.info.expiry_date).locale('da').format('LL')}}</span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- modal partner information -->
              <div class="hide col-12 px0">
                <h5>Company Information</h5>
                <h6><strong>{{partner.company}}</strong></h6>
                <p class="contact-info">CVR: <strong>{{partner.cvr}}</strong></p>
                <p class="contact-info">Email: <strong>{{partner.email}}</strong></p>
                <p class="contact-info" >Phone: <strong>{{partner.mobile}}</strong></p>
                <p class="" >Address: <strong>{{partner.address}} {{partner.city}}</strong></p>
              </div>
              <!-- modal customner information -->
              <div class="hide col-12 px0">
                <div class="text-right"></div>
                <h5 class="text-right">Kunde</h5>
                <div class="pull-right text-right">
                  <h6 class="text-strong">
                    <strong>{{customer.firstname}} {{customer.lastname}}</strong>
                  </h6>
                  <p class="contact-info">Email: <strong>{{customer.email}}</strong></p>
                  <p class="contact-info" >Phone: <strong>{{customer.mobile}}</strong></p>
                  <p class="" >Address: <strong>{{customer.mailingstreet}} {{customer.mailingcity}}</strong></p>
                </div>
              </div>
              <!-- modal description -->
              <div class="col-12 px0" v-if="quotation.info.subject || quotation.info.description">
                <h5 v-if="quotation.info.subject" v-text="quotation.info.subject"></h5>
                <div v-if="quotation.info.description" v-html="quotation.info.description"></div>
                <hr />
              </div>
              <!-- new modal invoice items -->
              <div class="clearfix">
                <div v-for="(item,index) in quotation.info.rows" :key="item.id">
                  <div class="py1 border-top mediumgrey-border">
                    <span class="hide" v-html="index + 1"></span>
                    <div>
                      <div class="flex justify-between items-start">
                        <span class="inline-block flex flex-column pr1">
                          <span class="h6 block light line-height-1">Antal:</span>
                          <span class="block semi-bold line-height-1"  v-text="item.quantity"></span>
                        </span>
                        <span class="inline-block flex-auto flex-column pr1" v-if="item.custom_name">
                          <span class="h6 block light line-height-1">Navn</span>
                          <span class="h6 block semi-bold line-height-2 mb0">{{item.custom_name}}</span> 
                          <span class="h6 block regular line-height-2 mb0" v-if="item.custom_description"></span>
                          <span class="inline-block flex flex-column mt1">
                            <span class="block flex justify-between items-center">
                              <span class="h6 darkblue regular line-height-1">Pris:</span>
                              <span class="h6 darkblue semi-bold line-height-1" v-text="formatNumber(item.unitPrice,2)"></span>
                            </span>
                            <span class="block flex justify-between items-center">
                              <span class="h6 darkblue regular line-height-1">Total</span>
                              <span class="h6 darkblue semi-bold line-height-1" v-text="formatNumber(item.amount,2)"></span>
                            </span>
                          </span>
                        </span>
                        <span class="hide inline-block flex flex-column">
                          <span class="inline-block flex flex-column pr1">
                            <span class="h6 block light line-height-1">Pris:</span>
                            <p v-text="formatNumber(item.unitPrice,2)"></p>
                            <p v-text="formatNumber(item.amount,2)"></p>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- new modal subtotal and total -->
              <div class="col-12 px0 flex flex-column border-top muted-border mt3 mb2 py2">
                <!-- subtotal -->
                <div class="col-12 px0 flex justify-between items-center">
                  <span class="h6 darkblue regular mb0">Subtotal (DKK)</span>
                  <span>
                    <span class="h6 darkblue semi-bold mb0" v-text="formatNumber(quotation.info.subtotal,2)"></span>
                  </span>
                </div>
                <!-- discount -->
                <div class="col-12 px0 flex justify-between items-center" v-if="quotation.info.subtotal_discount">
                  <div>
                    <span class="h6 darkblue regular mb0">Discount</span>
                    <span>
                      <span class="h6 darkblue semi-bold mb0" v-if="quotation.info.subtotal_discount_type">(%)</span>
                      <span class="h6 darkblue semi-bold mb0" v-else>(DKK)</span>
                    </span>
                  </div>
                  <div v-text="formatNumber(quotation.info.subtotal_discount_amount,2)"></div>
                </div>
                <!-- moms -->
                <div class="col-12 px0 flex justify-between items-center">
                  <span class="h6 darkblue regular mb0">Moms (25%)</span>
                  <template>
                    <span v-if="quotation.info.subtotal_tax">
                      <span class="h6 darkblue semi-bold mb0" v-html="formatNumber(quotation.info.subtotal_tax)"></span>
                    </span>
                    <span class="h6 darkblue semi-bold mb0" v-else></span>
                  </template>
                  
                </div>
                <!-- total -->
                <div class="col-12 px0 flex justify-between items-end">
                  <span class="h6 darkblue regular mb0">Total (DKK)</span>
                  <span>
                    <span class="h6 darkblue semi-bold mb0" v-text="formatNumber(quotation.info.total,2)"></span>
                  </span>
                </div>
                <!-- conditions -->
                <div class="col-12 px0">
                  <div class="mt2" v-if="quotation.info.tnc">
                    <p class="h6 darkblue line-height-2 mb0">
                      <span class="semi-bold block">Terms & Conditions:</span>
                      <span class="regular">{{quotation.info.tnc}}</span>
                    </p>
                  </div>
                  <div class="mt2" v-if="quotation.info.customer_note">
                    <p class="h6 darkblue line-height-2 mb0">
                      <span class="semi-bold block">Customer Note:</span>
                      <span class="regular">{{quotation.info.customer_note}}</span>
                    </p>
                  </div>
                  <div class="mt2" v-if="quotation.info.memo">
                    <p class="h6 darkblue line-height-2 mb0">
                      <span class="semi-bold block">Memo:</span>
                      <span class="regular">{{quotation.info.memo}}</span>
                    </p>
                  </div>
                </div>
              </div>
              <!-- new modal attachments -->
              <div v-if="quotation.files.length !== 0" class="py1 border-top mediumgrey-border">
                <!-- modal attachments -->
                <div class="col-12 px0">
                  <div>
                    <p class="block h6 semi-bold line-height-1">Attachments</p>
                    <ul class="list-reset">
                      <li class="flex justify-start items-center" v-for="attachment in quotation.files" :key="attachment.id">
                        <a class="block flex justify-start items-center">
                          <span class="mx2"><i class="el-icon-paperclip"></i></span>
                          <span class="h6 semi-bold line-height-1">{{attachment}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- new modal invoice -->
              <div class="hide col-12 px0">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <td class="text-strong">#</td>
                        <td class="text-strong">Item</td>
                        <td class="text-strong text-left">Type</td>
                        <td class="text-strong text-left" >Quantitly</td>
                        <td class="text-strong text-left">Unit prcie(Dkk)</td>
                        <td class="text-strong text-right" style="width:150px;">Amount</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in quotation.info.rows" :key="item.id">
                        <td v-text="index + 1"></td>
                        <td>
                          <span v-if="item.custom_name">{{item.custom_name}}</span>
                          <span v-else>{{item.description}}</span>
                        </td>
                        <td v-if="quotation.line_item_description" v-text="item.description"></td>
                        <b-form-select disabled v-model="item.type" :options="dataStatus"  class="text-dark rounded border-0">
                        </b-form-select>
                      </td>
                      <td  class="text-right" v-text="item.quantity"></td>
                      <td class="text-right" v-text="formatNumber(item.unitPrice,2)"></td>
                      <td class="text-right" v-text="formatNumber(item.amount,2)"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="hide col-12 px0" v-if="quotation.quotation_item">
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <td class="text-strong text-right">{{trans('quotation.subtotal')}} ({{quotation.currency.symbol}})</td>
                      <td style="width:150px;" class="text-right" v-text="formatNumber(quotation.subtotal,quotation.currency.decimal_place)"></td>
                    </tr>
                    <tr v-if="quotation.subtotal_discount">
                      <td class="text-strong text-right">{{trans('quotation.subtotal_discount')}}
                        <span v-if="quotation.subtotal_discount_type">(%)</span>
                        <span v-else>({{quotation.currency.symbol}})</span>
                      </td>
                      <td class="text-right" v-text="formatNumber(quotation.subtotal_discount_amount,getConfig('quotation_subtotal_discount_decimal_place'))"></td>
                    </tr>
                    <tr v-if="quotation.subtotal_tax">
                      <td class="text-strong text-right">{{trans('quotation.subtotal_tax')}} (%)</td>
                      <td class="text-right" v-text="formatNumber(quotation.subtotal_tax_amount,getConfig('quotation_subtotal_tax_decimal_place'))"></td>
                    </tr>
                    <tr v-if="quotation.subtotal_shipping_and_handling">
                      <td class="text-strong text-right">{{trans('quotation.subtotal_shipping_and_handling')}} ({{quotation.currency.symbol}})</td>
                      <td class="text-right" v-text="formatNumber(quotation.subtotal_shipping_and_handling_amount,getConfig('quotation_subtotal_shipping_and_handling_decimal_place'))"></td>
                    </tr>
                    <tr>
                      <td class="text-strong text-right">{{trans('quotation.total')}} ({{quotation.currency.symbol}})</td>
                      <td class="text-strong text-right" v-text="formatNumber(quotation.total,quotation.currency.decimal_place)"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- old modal attachments -->
            <div class="hide col-12 px0">
              <div v-if="quotation.files.length !== 0">
                <h5 class="card-title">Attachment</h5>
                <ul style="list-style: none;padding: 0;" class="m-t-10">
                  <li v-for="attachment in quotation.files" :key="attachment.id">
                    <a><i class="el-icon-paperclip"></i>{{attachment}}</a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- old modal invoice -->
            <div class="hide col-12 px0" style="margin-top: -17px;" >
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td class="text-strong text-right">Subtotal (DKK)</td>
                    <td style="width:150px;" class="text-right" v-text="formatNumber(quotation.info.subtotal,2)"></td>
                  </tr>
                  <tr v-if="quotation.info.subtotal_discount">
                    <td class="text-strong text-right">Discount
                      <span v-if="quotation.info.subtotal_discount_type">(%)</span>
                      <span v-else>(DKK)</span>
                    </td>
                    <td class="text-right" v-text="formatNumber(quotation.info.subtotal_discount_amount,2)"></td>
                  </tr>
                  <tr v-if="quotation.info.subtotal_tax">
                    <td class="text-strong text-right">Tax (%)</td>
                    <td class="text-right" v-text="formatNumber(quotation.info.subtotalTax,2)"></td>
                  </tr>
                  <tr>
                    <td class="text-strong text-right">Total (DKK)</td>
                    <td class="text-strong text-right" v-text="formatNumber(quotation.info.total,2)"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- old modal betingelser -->
            <div class="hide col-12 col-md-6">
              <blockquote style="margin-top: 10px;" v-if="quotation.info.tnc">
                <h6 class="card-title">Terms & Conditions:</h6>
                {{quotation.info.tnc}}
              </blockquote>
              <blockquote style="margin-top: 10px;" v-if="quotation.info.customer_note">
                <h6 class="card-title">Customer Note:</h6>
                {{quotation.info.customer_note}}
              </blockquote>
              <blockquote style="margin-top: 10px;" v-if="quotation.info.memo">
                <h6 class="card-title">Memo:</h6>
                {{quotation.info.memo}}
              </blockquote>
            </div>
            <!-- modal items -->
            <!-- <div class="col-12 col-md-6 pull-right" style="margin-top: -17px;" v-if="quotation.quotation_item">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td class="text-strong text-right">{{trans('quotation.subtotal')}} ({{quotation.currency.symbol}})</td>
                    <td style="width:150px;" class="text-right" v-text="formatNumber(quotation.subtotal,quotation.currency.decimal_place)"></td>
                  </tr>
                  <tr v-if="quotation.subtotal_discount">
                    <td class="text-strong text-right">{{trans('quotation.subtotal_discount')}}
                      <span v-if="quotation.subtotal_discount_type">(%)</span>
                      <span v-else>({{quotation.currency.symbol}})</span>
                    </td>
                    <td class="text-right" v-text="formatNumber(quotation.subtotal_discount_amount,getConfig('quotation_subtotal_discount_decimal_place'))"></td>
                  </tr>
                  <tr v-if="quotation.subtotal_tax">
                    <td class="text-strong text-right">{{trans('quotation.subtotal_tax')}} (%)</td>
                    <td class="text-right" v-text="formatNumber(quotation.subtotal_tax_amount,getConfig('quotation_subtotal_tax_decimal_place'))"></td>
                  </tr>
                  <tr v-if="quotation.subtotal_shipping_and_handling">
                    <td class="text-strong text-right">{{trans('quotation.subtotal_shipping_and_handling')}} ({{quotation.currency.symbol}})</td>
                    <td class="text-right" v-text="formatNumber(quotation.subtotal_shipping_and_handling_amount,getConfig('quotation_subtotal_shipping_and_handling_decimal_place'))"></td>
                  </tr>
                  <tr>
                    <td class="text-strong text-right">{{trans('quotation.total')}} ({{quotation.currency.symbol}})</td>
                    <td class="text-strong text-right" v-text="formatNumber(quotation.total,quotation.currency.decimal_place)"></td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          </div>
          </div>
          <div slot="modal-footer" class="col-12 border-none px0 mb3">
            <button type="buttom" slot="modal-cancel" class="col-5 h5 mx-auto standard-button p2 px3 flex justify-center items-center" @click="hideModal">
              <span class="semi-bold">Luk</span><span class="ml2"><i class="el-icon-close semi-bold"></i></span>
            </button>
          </div>
        </b-modal>
        <loading :show="show" :label="label" :overlay="overlay"></loading>
        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      </div>
    </div>
  </div>
</template>
<script>
  import loading from 'vue-full-loading'
  import Simplert from 'vue2-simplert'
  import datepicker from 'vuejs-datepicker'
  import {en, da} from 'vuejs-datepicker/dist/locale'
  import autosizeTextarea from '../../components/autosize-textarea'
  import fileUploadInput from '../../components/file-upload-input'
  import showError from '../../components/show-error'
  import moment from 'moment'
  import uuid from 'uuid/v4'
  import VueGallerySlideshow from 'vue-gallery-slideshow'
  import {ImageRating} from 'vue-rate-it'
  export default {
    name: 'userTilbud',
    components: {
      loading,
      moment,
      showError,
      VueGallerySlideshow,
      uuid,
      autosizeTextarea,
      fileUploadInput,
      Simplert,
      datepicker,
      ImageRating
    },
    data () {
      return {
        item: [],
        files: [],
        show: false,
        tilbudShow: false,
        newCreatorShow: false,
        offerModalShow: false,
        da: da,
        en: en,
        overlay: true,
        label: 'Loading...',
        quotations: [],
        quotation: {
          files: [],
          info: []
        },
        images: [],
        image: '',
        customer: {
          files: []
        },
        partner: [],
        app: [],
        dataStatus: [
          { value: 1, text: 'Quantity' },
          // { value: 1, text: 'Quantity' },
          { value: 2, text: 'Timepris' },
          // { value: 2, text: 'Hour' },
          { value: 3, text: 'Fastpris' }
          // { value: 3, text: 'Amount' }
        ],
        quotationForm: {
          id: '',
          customer_id: null,
          currency_id: null,
          date: moment().format('YYYY-MM-DD'),
          expiry_date: moment().add(7, 'days').format('YYYY-MM-DD'),
          expiry_date_detail: '',
          upload_token: '',
          item_type: '',
          rows: [],
          subject: '',
          description: '',
          subtotal: 0,
          subtotalDiscount: 0,
          line_item_discount_type: true,
          subtotalDiscount_type: false,
          subtotal_tax: 25,
          subtotalShippingAndHandling: 0,
          total: 0,
          reference_number: '',
          quotation_number: '',
          quotation_prefix: '',
          is_draft: 0,
          show_sub_total_tax: true,
          show_sub_total_discount: true,
          show_sub_total_shipping_and_handling: true,
          show_line_item_tax: true,
          show_line_item_discount: true,
          show_line_item_description: true,
          customer_note: '',
          memo: '',
          tnc: ''
        },
        index: null,
        tilbuds: [],
        item_details: [],
        customers: [],
        selected_customer: null,
        currencies: [],
        selected_currency: null,
        default_currency: {},
        item_types: [],
        selected_item_type: null,
        expiry_dates: [],
        selected_expiry_date: null,
        expiry_date_detail: '',
        clear_quotation_attachment: false,
        show_quantity: true,
        items: [],
        tilbud_id: '',
        showDismissibleAlert: false,
        starMessage: '',
        showHaandvearker: false,
        showImentor: false,
        messages: [],
        uuid: false,
        loading: true
      }
    },
    created () {
      if (screen.width <= 640) {
        this.showMobile = true
      } else {
        this.showMobile = false
      }
      if (screen.width >= 1900) {
        this.showXXL = true
      } else {
        this.showXXL = false
      }
      this.Reload()
    },
    mounted () {
    },
    methods: {
      Reload () {
        if (localStorage.getItem('haaid') !== '0') {
          this.showHaandvearker = true
        }
        if (localStorage.getItem('imentor') !== '0') {
          this.showImentor = true
        }
        this.show = true
        this.tilbud_id = this.$route.query.app
        this.salesPerson = localStorage.getItem('id_token_portal')
        var data = {operation: 'userTilbud', salesPerson: this.salesPerson, tilbud_id: this.tilbud_id}
        this.$http.post('', data, {emulateJSON: true})
          .then(
            response => {
              var res = response.body
              this.show = false
              if (res.login === false) {
                this.$router.push('/login')
              }
              this.loading = false
              this.customer = res.customer
              this.app = res.app
              this.quotations = res.tilbud
              this.items = res.customer.products
              this.images = res.customer.pic
              this.image = res.partner.image
              this.partner = res.partner
              this.quotationForm.reference_number = 'REF' + this.quotations.length + '-' + this.tilbud_id
            },
            response => {
              alert('error')
            }
          )
      },
      onClick (i) {
        this.index = i
      },
      onFileChange (e) {
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.createImage(files[0])
      },
      hideModal () {
        this.$refs.tilbudModal.hide()
      },
      showItemDetails (tilbud) {
        this.tilbudShow = !this.tilbudShow
        this.quotation = tilbud
      },
      createImage (file) {
        var reader = new FileReader()
        var vm = this
        reader.onload = (e) => {
          vm.image = e.target.result
        }
        reader.readAsDataURL(file)
      },
      removeImage: function (e) {
        this.image = ''
      },
      UpdateTilbud (files) {
        this.files = files
      },
      save () {
        this.quotationForm.is_draft = 1
        this.onSubmitTilbud()
      },
      send () {
        this.quotationForm.is_draft = 0
        this.onSubmitTilbud()
      },
      resetForm (evt) {
      },
      onSubmitTilbud (evt) {
        evt.preventDefault()
        if (this.quotationForm.total <= 0) {
          let obj = {
            title: 'Fejl',
            message: 'Total price is zero',
            type: 'error',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          return
        }
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var data = { operation: 'addTilbud', salesPerson: this.salesPerson, tilbud: JSON.stringify(this.quotationForm), files: JSON.stringify(this.files), tilbud_id: this.tilbud_id, is_draft: this.quotationForm.is_draft, image: this.image }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              this.show = false
              var res = response.body
              if (res.success) {
                let closeFn = function () {
                  this.$parent.quotationForm.is_draft = 0
                  this.$parent.quotationForm.rows = []
                  this.$parent.quotationForm.subject = ''
                  this.$parent.quotationForm.description = ''
                  this.$parent.quotationForm.subtotal = 0
                  this.$parent.quotationForm.subtotalDiscount = 0
                  this.$parent.quotationForm.line_item_discount_type = true
                  this.$parent.quotationForm.subtotalDiscount_type = false
                  this.$parent.quotationForm.subtotal_tax = 25
                  this.$parent.quotationForm.subtotalShippingAndHandling = 0
                  this.$parent.quotationForm.total = 0
                  this.$parent.quotationForm.customer_note = ''
                  this.$parent.quotationForm.memo = ''
                  this.$parent.quotationForm.tnc = ''
                  this.$parent.Reload()
                  const elem = this.$parent.$refs.addt
                  elem.click()
                }
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  onClose: closeFn,
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              } else {
                let obj = {
                  title: 'Fejl',
                  message: 'Fejl - Kontakt venligst administrator',
                  type: 'error',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }
            },
            response => {
              alert('error')
            }
          )
      },
      confirmRowDelete (row) {
        return dialog => this.deleteRow(row)
      },
      deleteRow (row) {
        let idx = this.quotationForm.rows.indexOf(row)
        if (idx > -1) {
          this.quotationForm.rows.splice(idx, 1)
        }
        this.calculate()
      },
      formatNumber (number, decimalPlace) {
        if (decimalPlace === undefined) {
          decimalPlace = 2
        }
        return this.roundNumber(number, decimalPlace)
      },
      formatType (item) {
        switch (new Date().getDay()) {
          case 1:
            return 'Quantity'
        }
      },
      roundNumber (number, precision) {
        precision = Math.abs(parseInt(precision)) || 0
        var multiplier = Math.pow(10, precision)
        return (Math.round(number * multiplier) / multiplier)
      },
      confirmDelete (quotation) {
        return dialog => this.deleteQuotation(quotation)
      },
      calculate () {
        let total = 0
        this.quotationForm.rows.forEach(row => {
          let discount = 0
          discount = this.formatNumber(discount)
          row.discount = discount
          let tax = 0
          tax = this.formatNumber(tax)
          row.tax = tax
          let quantity = this.show_quantity ? row.quantity || 1 : 1
          quantity = this.formatNumber(quantity)
          row.quantity = quantity
          let unitPrice = row.unitPrice || 0
          unitPrice = this.formatNumber(unitPrice)
          row.unitPrice = unitPrice
          let price = quantity * unitPrice
          // price = price - (this.quotationForm.line_item_discount_type ? (price * discount / 100) : discount)
          // price = price + (price * tax / 100)
          let amount = this.formatNumber(price)
          row.amount = amount
          total = total + amount
        })
        this.quotationForm.subtotal = this.formatNumber(total)
        let subtotalDiscount = this.quotationForm.show_sub_total_discount ? this.quotationForm.subtotalDiscount || 0 : 0
        subtotalDiscount = this.formatNumber(subtotalDiscount)
        this.quotationForm.subtotalDiscount = subtotalDiscount
        let subtotalTax = 25
        subtotalTax = this.formatNumber(subtotalTax)
        this.quotationForm.subtotalTax = subtotalTax
        let subtotalShippingAndHandling = this.quotationForm.show_sub_total_shipping_and_handling ? this.quotationForm.subtotalShippingAndHandling || 0 : 0
        subtotalShippingAndHandling = this.formatNumber(subtotalShippingAndHandling)
        this.quotationForm.subtotalShippingAndHandling = subtotalShippingAndHandling
        total = total - (this.quotationForm.subtotalDiscount_type ? (total * subtotalDiscount / 100) : subtotalDiscount)
        total = total + (total * subtotalTax / 100)
        total = total + parseFloat(subtotalShippingAndHandling)
        this.quotationForm.total = this.formatNumber(total)
      },
      addRow () {
        this.quotationForm.rows.push({
          uuid: uuid(),
          name: '',
          selected_item: null,
          show_custom_item: false,
          custom_name: '',
          quantity: '1',
          unitPrice: '',
          discount: '',
          tax: '',
          type: 1,
          amount: '',
          description: ''
        })
      },
      trans (text) {
        return text
      },
      getConfig (text) {
        return text
      }
    }
  }
</script>
<style v-if="showMobile">
.vdp-datepicker > .input-group > input {
  font-size: 16px;
  text-align: center;
}
.el-upload-dragger {
  border: 0!important;
}
.el-upload-dragger:hover {
  border: 0!important;
}
.el-upload,
.el-upload-dragger {
  width:100%!important;
  height: auto!important;
}
.wizard-tab-content,
.vue-form-wizard,
.wizard-card-footer {
  padding: 0!important;
}
.wizard-nav, .wizard-progress-with-circle,
.wizard-header {
  display: none!important;
}
.offerModal > .modal-footer {
  border-width: 0!important;
}
</style>
<style>
.expireTableHeader {
  width:110px;
}
.addressTableHeader {
  width:120px;
}
.dateTableHeader {
  width:100px;
}
.statusTableHeader {
  width:120px;
}
.saveDraftSetup > .custom-control-indicator {
  top: 7px!important;
}
.plusminuscell {
  width: 30px;
}
.itemcell {
  width:200px;
}
.typecell {
  width:120px;
}
.quantitycell {
  width:80px;
}
.pricecell {
  width: 120px;
}
.amountcell {
  width:60px;
}
.table {
  width: 100%;
  max-width: 100%;
  background-color: transparent;
  font-family: 'canada-type-gibson';
}
.table td,
.table th {
  padding: .5rem!important;
  vertical-align: top;
  /* border-top: 1px solid #dee2e6 */
}
/* .table tr > td:nth-child(2) {
  text-align: center;
} */
/* .table thead th {
  vertical-align: bottom;
  font-weight: 500;
} */
/* .table tbody+tbody {
  border-top: 2px solid #dee2e6
} */
.table .table {
  background-color: #fff
}
/* .table-sm td,
.table-sm th {
  padding: .5rem;
  line-height: 1.375;
} */
/* .table-bordered,
.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6
}
.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px
} */
.table-borderless tbody+tbody,
.table-borderless td,
.table-borderless th,
.table-borderless thead th {
  border: 0
}
.image {
  /* width: 200px;
  height: 200px; */
  cursor: pointer;
  margin-right: 10px;
}
.contact-info{line-height:6px}
.vdp-datepicker > div > input[type="text"] {
  background:  transparent;
  border: 0;
  outline:  none;
}
.custom-control-description {
  position: relative;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// userTilbud.vue?5f9aed5f